import Vue from 'vue'
import API from '@/api/callApi.js'
import endpoints from '@/api/endpoints';

export default {
    namespaced : true,
    state : {

    	portal : {
    		data : null,
    		loaded : false,
    		loading : false,
    		upserting : false,
    		error : null,
			publicPortal : null,
			publicPortalLoading : false,
    	},

    },
    mutations : {

		setPortalData (state, value) {

			state.portal.data = value;

			if (state.portal.data === null) {

				Vue.set(state.portal, 'data', {});
				state.portal.data.id = null;
				state.portal.data.establishment_id = null;
				state.portal.data.status = null;
				state.portal.data.banner_image = null;
				state.portal.data.title = "WIFI GRATUIT";
				state.portal.data.color_main = null;
				state.portal.data.color_secondary = null;
				state.portal.data.toggle_covid = false;
				state.portal.data.message = "Tapez votre message...";
				state.portal.data.fidelity_program = "Tapez votre message...";
				state.portal.data.address_cgu = null;
				state.portal.data.address_confidentiality = null;
				state.portal.data.menu = null;
				state.portal.data.layout = null;
			}

		},
		
		setPortalDataField (state, params) {
			state.portal.data[params.field] = params.value;
		},
		setPortalLoaded (state, value) {
			state.portal.loaded = value;
		},
		setPublicPortalData (state, value) {
			state.portal.publicPortal = value;
			if (state.portal.publicPortal === null) {

				Vue.set(state.portal.publicPortal, 'publicPortal', {});
				state.portal.publicPortal.id = null;
				state.portal.publicPortal.establishment_id = null;
				state.portal.publicPortal.status = null;
				state.portal.publicPortal.banner_image = "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8cmVzdGF1cmFudHxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60";
				state.portal.publicPortal.title = "WIFI GRATUIT";
				state.portal.publicPortal.color_main = null;
				state.portal.publicPortal.color_secondary = null;
				state.portal.publicPortal.toggle_covid = false;
				state.portal.publicPortal.message = "Entrez un message d'acceuil pour vos futurs clients";
				state.portal.publicPortal.fidelity_program = "Tapez votre message...";
				state.portal.publicPortal.address_cgu = null;
				state.portal.publicPortal.address_confidentiality = null;
				state.portal.publicPortal.menu = null;
				state.portal.publicPortal.layout = null;
			}
		},
		setPortalLoading (state, value) {
			state.portal.loading = value;
		},
		setPublicPortalLoading (state, value) {
			state.portal.publicPortalLoading = value;
		},
		setPortalError (state, value) {
			state.portal.error = value;
		},
		setPortalUpserting (state, value) {
			state.portal.upserting = value;
		}

    },
    actions : {

    	/*
		** Récupère les données du portail, renvoie nul si pas de portail
		*/

    	loadPortalData ({ state, commit }, { parameters }) {

    		if (state.portal.loaded || state.portal.loading) {
    			return;
    		}

    		commit('setPortalLoading', true);

    		let url = endpoints.baseURL + API.processUrl(endpoints.endpoints.loadPortalManager, {
    			establishment_id : parameters.establishment_id
    		});

    		API.makeGet(url, null, true)
    		.then ( response => {
				console.log("portal loaded", response);
    			commit('setPortalLoaded', true);
    			commit('setPortalData', response.data.payload);
    		})
    		.catch ( response => {
    			commit('ui/triggerAlert', {
	    				type : 'error',
	    				msg : "Une erreur est survenue lors du chargement des inforamtions du portail."
    				}, { root : true });
    		})
    		.finally ( response => {
    			commit('setPortalLoading', false);
    		});

    	},


		loadPublicPortalData ({ state, commit }, { parameters }) {

    		if (state.portal.loaded || state.portal.loading) {
    			return;
    		}

    		commit('setPortalLoading', true);

    		let url = endpoints.baseURL + API.processUrl(endpoints.endpoints.publicPortal, {
    			establishment_id : parameters.establishment_id
    		});

    		API.makeGet(url, null, true)
    		.then ( response => {
    			commit('setPublicPortalData', response.data.payload);
    			commit('setPublicPortalLoading', true);
				parameters.success();
    		})

    	},




    	/*
		** Crée ou met à jour le portail
		*/

		upsertPortalData ({ state, commit }, { parameters }) {

			if (state.portal.upserting) {
				return;
			}

			commit('setPortalUpserting', true);

			let url;

			if (state.portal.data.id === null) {
				url = endpoints.baseURL + API.processUrl(endpoints.endpoints.createPortal, {
	    			establishment_id : parameters.establishment_id
	    		});
			}
			else {
				url = endpoints.baseURL + API.processUrl(endpoints.endpoints.updatePortal, {
	    			portal_id : state.portal.data.id
	    		});
			}

			let requestParameters = Object.assign({}, state.portal.data);

			API.makePost(url, requestParameters, true)
    		.then ( response => {
    			console.log("response", response);
    		})
    		.catch ( response => {
    			commit('ui/triggerAlert', {
	    				type : 'error',
	    				msg : "Une erreur est survenue lors de la mise à jour des inforamtions du portail."
    				}, { root : true });
    		})
    		.finally ( response => {
    			commit('setPortalUpserting', false);
    		});

		}

    }
};
